import { lazy } from 'react';
import Loadable from 'src/components/extended/Loadable';
import MainLayout from 'src/components/layout/MainLayout';
import Employees from 'src/pages/Employees';
import Offices from 'src/pages/Offices';
import TransferOrders from 'src/pages/TransferOrders';
import TransferPool from 'src/pages/TransferPool';
import TransferToOtherDistrict from 'src/pages/TransferToOtherDistrict';

const Home = Loadable(lazy(async () => await import('src/pages/Home')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Home />,
      breadcrumb: 'Home'
    },
    {
      path: 'home',
      element: <Home />,
      breadcrumb: 'Home'
    },
    {
      path: 'office',
      element: <Offices />,
      breadcrumb: 'Office'
    },
    {
      path: 'office/:parentId',
      element: <Offices />,
      breadcrumb: 'Office'
    },
    {
      path: 'employees',
      element: <Employees />,
      breadcrumb: 'Employees'
    },
    {
      path: 'transfer-list',
      element: <TransferPool />,
      breadcrumb: 'Transfer List'
    },
    {
      path: 'transfer-orders',
      element: <TransferOrders />,
      breadcrumb: 'Transfer Orders'
    },
    {
      path: 'transfer-To-Other-District',
      element: <TransferToOtherDistrict />,
      breadcrumb: 'Transfer-To-Other-District'
    }
  ]
};

export default MainRoutes;
